const f = {
  id: "LuckyForLife",
  name: "Lucky For Life",
  style: {
    colorPrimary: "#047940",
    extraBall: {
      bg: "#047940",
      color: "#ffffff"
    }
  }
};
export {
  f as default
};
